import LocalizedStrings from 'localized-strings';

import { Feature } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    canAccessFeature: 'You can now access the {feature} feature.',
    continue: 'Continue',
    couldOrderCard: 'You can now order your Mastercard Business World Debit.',
    features: {
      [Feature.BulkTransfers]: 'bulk transfers',
    },
    later: 'Later',
    orderCard: 'Order my card',
    title: 'Thank you for choosing Shine {planName}!',
  },
  fr: {
    canAccessFeature:
      'Vous pouvez maintenant accéder à la fonctionnalité de {feature}.',
    continue: 'Continuer',
    couldOrderCard:
      'Vous pouvez dès à présent commander votre carte Mastercard Business World Debit.',
    features: {
      [Feature.BulkTransfers]: 'virement groupés',
    },
    later: 'Plus tard',
    orderCard: 'Commander ma carte',
    title: 'Merci d’avoir choisi Shine {planName}\u00A0!',
  },
});

export default locales;
